import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "plan",
    "amounts",
    "paid",
    "bonus",
    "quantityField",
    "quantity",
  ];

  connect() {
    this.update();
  }

  update() {
    const option = this.planTarget.selectedOptions[0];
    const storedValue = option?.dataset.storedValue === "true";

    this.amountsTarget.hidden = !storedValue;
    this.paidTarget.required = storedValue;
    this.bonusTarget.required = storedValue;
    this.quantityFieldTarget.hidden = storedValue;
    if (!storedValue) {
      this.setBonus("0", true);
      return;
    }

    this.quantityTarget.value = 1;
    this.paidTarget.value = option.dataset.paidAmount || "";
    const bonus = option.dataset.bonusAmount || "0";
    this.setBonus(bonus, Number.parseFloat(bonus) <= 0);
  }

  paidChanged() {
    const paid = Number.parseFloat(this.paidTarget.value);
    if (!Number.isFinite(paid)) {
      this.setBonus("0", true);
      return;
    }

    const matching = [...this.planTarget.options]
      .filter((option) => option.dataset.storedValue === "true")
      .filter((option) => Number.parseFloat(option.dataset.paidAmount) <= paid)
      .sort(
        (a, b) =>
          Number.parseFloat(b.dataset.paidAmount) -
          Number.parseFloat(a.dataset.paidAmount),
      )[0];

    if (matching) this.planTarget.value = matching.value;
    const bonus = matching?.dataset.bonusAmount || "0";
    this.setBonus(bonus, !matching || Number.parseFloat(bonus) <= 0);
  }

  setBonus(value, disabled = false) {
    this.bonusTarget.replaceChildren(new Option(`赠送 ${value} 元`, value));
    this.bonusTarget.value = value;
    this.bonusTarget.disabled = disabled;
  }
}
